import { useMutation } from '@tanstack/react-query';
import { endpoints, ID } from '@rossum/api-client';
import { api } from '../../../../lib/apiClient';
import { CredentialSecret } from '../types';

type TestCredentialPayload = {
  /** When provided, the already stored credential is tested instead. */
  credentialId?: ID;
  type: string;
  secret: CredentialSecret;
};

export const useTestCredential = () =>
  useMutation({
    mutationFn: ({ credentialId, type, secret }: TestCredentialPayload) =>
      credentialId === undefined
        ? api.request(endpoints.integrationCredentials.test({ type, secret }))
        : api.request(
            endpoints.integrationCredentials.testExisting(credentialId, {
              secret,
            })
          ),
  });
